import React, { useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import CustomPagination from '../CustomPagination/CustomPagination';
import CommonModal from '../Modal/CommonModal';
import CancelScheduleBookForm from '../CancelScheduleBookForm/CancelScheduleBookForm';
import ScheduleBookingForm from '../ScheduleBookingForm/ScheduleBookingForm';
import UpcomingBookingSkeleton from '../Skeleton/ViewBooking/UpcomingBookingSkeleton/UpcomingBookingSkeleton';

import history from '../../history';
import messages from '../../locale/messages';
import { closeHeaderModal } from '../../actions/siteadmin/modalActions';
import { scheduleDateSplitUp } from '../../helpers/bookingHelper';

import noResult from "../../../public/Icons/darkNoResultsFound.svg";
import BookingItem from '../UpcomingBooking/BookingItem/BookingItem';
import { LinkPlusIcon } from '../Common/Assets/SVGIcon/CommonSvgIcon';

import bt from '../../components/commonStyle.css'
import s from "./MyBookings.css"





const MyBookings = ({ type, loading, refetch, data, intl: { formatMessage } }) => {

    const [currentPage, setCurrentPage] = useState(1)
    const dispatch = useDispatch()

    const scheduleBookingForm = useSelector(state => state?.adminModalStatus?.scheduleBookingForm)
    const cancelScheduleBooking = useSelector(state => state?.adminModalStatus?.cancelScheduleBooking)
    const scheduleFrom = useSelector(state => state?.adminModalStatus?.formData?.scheduleFrom)
    const id = useSelector(state => state?.adminModalStatus?.formData?.id)
    const scheduleId = useSelector(state => state?.adminModalStatus?.formData?.scheduleId)
    const currency = useSelector(state => state?.adminModalStatus?.formData?.currency)
    const userId = useSelector(state => state?.adminModalStatus?.formData?.userId)
    const isUserBooking = useSelector(state => state?.adminModalStatus?.formData?.isUserBooking)

    const redirectSearch = () => {
        history.push('/category?type=all')
    }

    const paginationData = (currentPage) => {
        let variables = { currentPage };
        setCurrentPage(currentPage)
        refetch(variables);
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    const handleSelect = (key) => {
        setCurrentPage(1)
        let variables = {
            currentPage: 1
        };
        refetch(variables)
        key == 1 ? history.push('/bookings/upcoming') : history.push('/bookings/previous');
    }
    const closeCancelScheduleModal = () => {
        dispatch(closeHeaderModal('cancelScheduleBooking'));
    }
    const closeUpdateScheduleModal = () => {
        dispatch(closeHeaderModal('scheduleBookingForm'))
    }

    let formData = {
        bookingId: id,
        scheduleFrom,
        scheduleId,
        currentPage,
        currency,
        userId,
        isUserBooking
    }
    let scheduleInitialValues = scheduleDateSplitUp(parseInt(scheduleFrom));
    if (loading) {
        return <UpcomingBookingSkeleton isBooking />
    }
    return (
        <div className={s.myBookingSectionWrapper}>
            <CommonModal
                title={scheduleBookingForm ? formatMessage(messages.updateSchedule) : formatMessage(messages.cancelJob)}
                onHide={scheduleBookingForm ? closeUpdateScheduleModal : closeCancelScheduleModal}
                modalStatus={scheduleBookingForm ? scheduleBookingForm : cancelScheduleBooking} >
                {scheduleBookingForm ? <ScheduleBookingForm initialValues={scheduleInitialValues} formData={formData} /> : <CancelScheduleBookForm formData={formData} />}
            </CommonModal>
            <h3 className={s.myBookingSectionTitle}><FormattedMessage {...messages.myBookings} /></h3>
            <div>
                <Tabs activeKey={type == 'upcoming' ? 1 : 2} onSelect={(e) => handleSelect(e)} className={'manualListTab'}>
                    <Tab eventKey={1} title={<FormattedMessage {...messages.currentBookingsText} />} />
                    <Tab eventKey={2} title={<FormattedMessage {...messages.pastBookingsText} />} />
                </Tabs>
            </div>
            {data?.results?.length > 0 &&
                <div className={s.myBookingCardListContainer}>
                    {data?.results?.map((item, index) => {
                        return (
                            <BookingItem
                                key={index}
                                id={item?.id}
                                currency={item?.currency}
                                categoryImage={item?.categoryDetails?.bannerImage}
                                amount={item?.userPayableFare}
                                categoryName={item?.categoryDetails?.name}
                                startLocation={item?.startLocation}
                                endLocation={item?.endLocation}
                                pricingType={item?.pricingType}
                                bookingType={item?.bookingType}
                                type={type}
                                scheduleFrom={item?.scheduleBooking?.scheduleFrom}
                                status={item?.status}
                                paymentStatus={item?.paymentStatus}
                                dateAndTime={item?.createdAt}
                                scheduleId={item?.scheduleBooking?.id}
                                userId={item?.userDetails?.userId}
                            />
                        )
                    })}
                </div>
            }
            {data?.results?.length > 0 &&
                <div className={bt.spaceTop5}>
                    <CustomPagination
                        total={data.count}
                        currentPage={currentPage}
                        defaultCurrent={1}
                        defaultPageSize={5}
                        change={paginationData}
                        paginationLabel={formatMessage(messages.myBookings)}
                    />
                </div>
            }
            {data?.results?.length === 0 &&
                <div className={bt.noResultSection}>
                    <img src={noResult} alt="No Result" />
                    <p className={bt.noResultText}><FormattedMessage {...messages.noBookings} /></p>
                    <div className={bt.commonLinkWithIconContainer}>
                        <div onClick={() => redirectSearch()} className={bt.commonLinkWithIcon}>
                            <LinkPlusIcon />
                            <FormattedMessage {...messages.createNewBooking} />
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default injectIntl(withStyles(bt, s)(MyBookings))